import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FMPTextField from '../ui/FMPTextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles } from '@material-ui/core/styles';

const styles = () => {
	return {
		sectionHeader : {
			margin : '30px 0px 10px 0px',
			textAlign : 'left',
			textTransform : 'uppercase',
			fontSize : 14,
			color : '#777',
			fontWeight : 900,
			letterSpacing : 2,
		},
		inputGroup : {
			borderLeft : '5px solid #ccc',
			marginTop : 10,
			marginBottom: 20
		},
		primaryContact : {
			textTransform: 'uppercase',
			fontSize: 13,
			fontWeight: 900,
			color: 'green',
		},
		addInputButton : {
			borderRadius : '100px',
			marginTop : 20,
		},
	};
};

class Contacts extends Component {
	render () {
		const { contacts, controller, classes, isDisabled } = this.props;
		return (<div>
			<div className={classes.sectionHeader}>Contacts</div>

			{contacts.map((contact, i) => { return (
				<Grid key={i} container spacing={3} className={classes.inputGroup}>
					<Grid item xs={12} md={6}>
						{i === 0 &&
						<div className={classes.primaryContact}>Primary</div>
						}

						<Grid spacing={2} container>
							<FMPTextField
								name={'contacts'}
								attr={'name'}
								index={i}
								label={"Full Name"}
								controller={controller}
								contained={false}
							/>
							<FMPTextField
								name={'contacts'}
								attr={'title'}
								index={i}
								label={"Title"}
								controller={controller}
								contained={false}
							/>
						</Grid>

						<Grid spacing={2} container>
							<FMPTextField
								name={'contacts'}
								attr={'officePhoneNumber'}
								index={i}
								label={"Office Phone #"}
								controller={controller}
								contained={false}
							/>
							<FMPTextField
								name={'contacts'}
								attr={'mobilePhoneNumber'}
								index={i}
								label={"Mobile Phone #"}
								controller={controller}
								contained={false}
							/>
						</Grid>

						<FMPTextField
							name={'contacts'}
							attr={'email'}
							index={i}
							label={"Email"}
							controller={controller}
							md={12}
						/>
						<FMPTextField
							name={'contacts'}
							attr={'note'}
							index={i}
							label={"Notes"}
							controller={controller}
							md={12}
						/>
					</Grid>
					<Grid item xs={12} md={1}>
						{contacts.length >= 2 &&
						<IconButton
							color="primary"
							aria-label="Delete"
							onClick={() => controller.removeInput('contacts', i)}
						>
							<DeleteIcon/>
						</IconButton>
						}
					</Grid>
				</Grid>
			);
			})}

			<Button
				variant="contained"
				className={classes.addInputButton}
				onClick={() => controller.addInput('contacts')}
				disabled={isDisabled}
			>
				ADD ANOTHER CONTACT
			</Button>
		</div>);
	}
}

Contacts.propTypes = {
	classes : PropTypes.object,
	controller: PropTypes.object.isRequired,
	contacts : PropTypes.array.isRequired,
	isDisabled : PropTypes.bool,
};
export default _.flow([
	withStyles(styles),
])(Contacts);
